export default __webpack_public_path__ + "static/media/Design.f781bd53.pdf";